import Vue from "vue";
import sticky from "@/directives/sticky";

Vue.directive("sticky", sticky);